import { render, staticRenderFns } from "./PatientModal.vue?vue&type=template&id=639b8aa5&scoped=true"
import script from "./PatientModal.vue?vue&type=script&lang=js"
export * from "./PatientModal.vue?vue&type=script&lang=js"
import style0 from "./PatientModal.vue?vue&type=style&index=0&id=639b8aa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b8aa5",
  null
  
)

export default component.exports